import React from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { Features } from './components/Features';
import { Bonuses } from './components/Bonuses';
import { PricingOffer } from './components/PricingOffer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { UrgencyClose } from './components/UrgencyClose';
import { Footer } from './components/Footer';
// CRITICAL: Cart link constant used across all CTAs
const CART_LINK = 'https://tienda-online-20888.myshopify.com/checkouts/cn/hWNC1lDkDM4BtTOG8xt6vBp4/es-ar?_r=AQABkLbhFSswxpv12SmT6NCH0HpU8MCW26GvTPn1xVrgSyU&preview_theme_id=160745357530';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-blush selection:text-brand-wine" data-id="element-0">
      <AlertBar data-id="element-1" />
      <main data-id="element-2">
        <Hero cartLink={CART_LINK} data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <Features data-id="element-5" />
        <Bonuses data-id="element-6" />
        <PricingOffer cartLink={CART_LINK} data-id="element-7" />
        <Guarantee data-id="element-8" />
        <Testimonials data-id="element-9" />
        <UrgencyClose cartLink={CART_LINK} data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}